import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface MessageBannerProps {
  color?: string;
  iconColor?: string;
  iconName: IconName;
  isRounded: boolean;
  className?: string;
}

/*
 * Style.
 */

interface BannerStyleProps {
  $color?: string;
  $isRounded: boolean;
}
const MessageBannerDiv = styled.div<BannerStyleProps>`
  grid-area: banner;
  margin-top: 0px;
  margin-bottom: -32px;

  display: grid;
  grid-template-columns: auto auto fit-content(100%) 1fr auto;
  grid-template-areas: 'title-icon title subtitle info-tooltip action';
  grid-column-gap: 5px;
  padding: 1px 5px 33px 16px;
  align-items: center;

  background-color: ${(p) => p.$color};
  border-radius: ${(p) => (p.$isRounded ? '15px 15px 0px 0px' : '0px')};
`;

const StyledIconDiv = styled.div`
  grid-area: title-icon;
  margin: 9px 0;
`;

/*
 * Component.
 */

export const MessageBanner: FC<PropsWithChildren<MessageBannerProps>> = (props) => {
  const theme = useUserTheme();

  return (
    <MessageBannerDiv $color={props.color} $isRounded={props.isRounded} className={props.className}>
      <StyledIconDiv>
        <Icon name={props.iconName} color={props.iconColor || theme.alphas.white50} />
      </StyledIconDiv>
      {props.children}
    </MessageBannerDiv>
  );
};
